module.exports = __webpack_public_path__ + "img/ic_copy.5a1e473a.svg";